module.exports = __webpack_public_path__ + "img/monster-gray-1.e4daa06e.png";